import { FC, useState } from 'react';
import { ButtonStyles, Drawer, ButtonSize, useTranslation, ButtonWidth } from '@nextgen-web-framework/all';
import { Contact, ContactType, OwnerType } from '@commerce-profile-webcomponents/sdk';
import AddNewAddressDisplayText from '../AddNewAddressDisplayText/AddNewAddressDisplayText';
import AddressInput from '../../AddressInput/AddressInput';
import ButtonWithLoading from '../../Common/ButtonWithLoading/ButtonWithLoading';
import type { AddNewAddressProps } from './types/propTypes';
import styles from './AddNewAddress.module.scss';

export const AddNewAddress: FC<AddNewAddressProps> = ({
  onConfirmClick,
  accountNumber = '', // Will be mandatory in next release to avoid error
  contactType = ContactType.Shipping,
  ownerType = OwnerType.Profile,
  useMobileView = true,
  useAddressLookup,
  isLoading = false,
  ownerId = '',
  addNewButtonText,
  onAddNewButtonClick,
  disableDeliveryInstructions = false,
}) => {
  const t = useTranslation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const onTextlinkClick = () => {
    if (onAddNewButtonClick) {
      onAddNewButtonClick();
    } else {
      setIsDrawerOpen(true);
    }
  };

  const callback = (contact?: Contact) => {
    if (contact) {
      onConfirmClick?.(contact);
    }
  };

  return (
    <>
      {isDrawerOpen ? (
        <Drawer
          header={t('profile.addNewAddress.heading')}
          closeIcon
          className="address-book-drawer"
          onClose={() => setIsDrawerOpen(false)}
          bottomGap={0}
          useReactPortal={true}
          portalContainerId={'react-portal-drawer'}
          footer={
            <div className={styles['confirm-button']} data-testid="confirm-button">
              <ButtonWithLoading
                form="shipping-address-form-id"
                title="Confirm"
                id="address-confirm-button"
                buttonWidth={ButtonWidth.FULL_WIDTH}
                buttonStyle={ButtonStyles.SOLID}
                size={ButtonSize.MEDIUM}
                isLoading={isLoading}
              />
            </div>
          }
        >
          <div className={styles['shipping-address-form']}>
            <AddressInput
              hideConfirmButton={true}
              callback={callback}
              accountNumber={accountNumber}
              contactType={contactType}
              ownerType={ownerType}
              ownerId={ownerId}
              // Use mobile view in drawer, because it's showing in single column
              useMobileView={useMobileView}
              lookupEnabled={useAddressLookup}
              disableDeliveryInstructions={disableDeliveryInstructions}
            />
          </div>
        </Drawer>
      ) : (
        <AddNewAddressDisplayText
          onTextlinkClick={onTextlinkClick}
          isInsideDrawer={false}
          buttonText={addNewButtonText}
        />
      )}
    </>
  );
};
export default AddNewAddress;
